<template>
  <div>
    <el-dialog
      title="盒马人员录入"
      :visible.sync="addVisible"
      width="1000px"
      :close-on-click-modal="false"
      center
    >
      <p style="color: red" v-if="TimeFlag">服务超时，请刷新页面</p>
      <!-- <div class="share-servant-wrapper">


      </div>-->
      <!-- <el-row v-if="!isIdcard " style="height:376px"> -->

      <div class="readCardTip">证件照片识别信息</div>
      <div style="color:red;font-size:14px;margin:8px 0px 20px 28px;overflow:hidden">
        注意：支持5M以内，png，jpg，jpeg格式上传，要求边缘完整，无明显反光，尽可能清晰可辨识。
        <!-- <el-button type="primary" style="float:right" plain @click="confIdentifyBtn">确认识别</el-button> -->
      </div>
      <el-form
        :inline="true"
        size="small"
        :model="servantIdCardPic"
        ref="servantIdCardPic"
        label-width="100px"
        class="servantIdCardPic"
        :rules="rules"
        label-position="top"
      >
        <el-row>
          <el-col :span="10">
            <el-form-item label="上传正面（人像面）照片" style="height:180px">
              <el-upload
                class="upload-demo"
                action="123"
                :limit="1"
                :on-remove="handleRemoveA"
                accept=".png, .jpg, jpeg"
                :file-list="fileListFront"
                list-type="picture"
                :on-change="handleOnChangeA"
                :before-upload="beforeAvatarUploadA"
                :auto-upload="false"
              >

                <el-button size="small" type="primary" style="float:left">点击上传</el-button>
                  <img  style="width:200px;display:inline-block;margin-left:14px;" src="../../../assets/image/card-front.png" v-show="fileFrontPhoto==''||fileFrontPhoto==null"/>
              </el-upload>

            </el-form-item>

          </el-col>
          <el-col :span="10">
            <el-form-item label="上传反面（国徽面）照片" style="height:180px">
              <el-upload
                class="upload-demo"
                action="123"
                :on-remove="handleRemoveB"
                accept=".png, .jpg, jpeg"
                :file-list="fileListBack"
                list-type="picture"
                :on-change="handleOnChangeB"
                :auto-upload="false"
                :limit="1"
              >

                <el-button size="small" type="primary" style="float:left">点击上传</el-button>
                  <img  style="width:200px;display:inline-block;margin-left:14px;" src="../../../assets/image/card-back.png" v-show="fileBackPhoto==''||fileBackPhoto==null"/>
              </el-upload>

            </el-form-item>

          </el-col>
          <el-col :span="4" style="padding-top:50px;">
            <el-button type="primary" plain @click="confIdentifyBtn">确认识别</el-button>
          </el-col>
        </el-row>


        <el-row>
          <el-col :span="8">
            <el-form-item label="姓名：" prop="workerName">
              <el-input v-model="servantIdCardPic.workerName" disabled style="width:250px"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="身份证号码：" prop="workerIdcard">
              <el-input v-model="servantIdCardPic.workerIdcard" disabled style="width:250px"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="服务者电话" prop="workerTel">
              <el-input
                v-model="servantIdCardPic.workerTel"
                maxlength="11"
                placeholder="请输入服务者电话"
                style="width:250px"
              ></el-input>
              <div style="color:red;font-size: 12px">*请仔细核对手机号是否正确!</div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="工作城市" prop="cityId">
              <el-select
                v-model="servantIdCardPic.cityId"
                placeholder="请选择城市"
                filterable
                style="width:250px;"
              >
                <el-option
                  v-for="(item, index) in cityList"
                  :key="index"
                  :label="item.cityName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
             <el-form-item label="服务站"  prop="stationId">
                    <el-select v-model="servantIdCardPic.stationId"   clearable placeholder="请选择服务站"
                        filterable>
                        <template v-for="(item, index) in allStationList">
                            <el-option :key="index" v-if="item.cityId == servantIdCardPic.cityId"
                                :label="item.stationName" :value="item.id + ''"> </el-option>
                        </template>
                    </el-select>
                </el-form-item>
            </el-col>

          <el-col :span="8">
            <el-form-item label="工作业务线" prop="buzLine">
              <el-select
                v-model="servantIdCardPic.buzLine"
                style="width:250px"
                placeholder="请选择"
                filterable
              >
                <el-option
                  v-for="(item, index) in workTypes"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>


      <span slot="footer" class="dialog-footer">
        <el-button @click="addVisible=false">关闭</el-button>
        <el-button type="primary" plain @click="confAddServantBtn('servantIdCardPic')">下一步</el-button>

      </span>
    </el-dialog>

    <!-- 重复提示 -->
    <el-dialog
      title="新增服务者"
      :visible.sync="tipVisible"
      width="900px"
      :close-on-click-modal="false"
      center
    >
      <p style="color:red;margin:10px 0px;">{{ resfranch }}</p>
      <!-- <p style="color:red;margin:10px 0px;">此保姆已在 {{resfranch}} 名下，不能重复录入！</p>
      <p v-if="resCardID">身份证号：{{resCardID}}</p>-->
      <p style="text-align:center;">引导服务者打开服务者小程序，签署服务合作协议后自动上线</p>
      <div style="text-align:center;">
        <img src="../../../assets/image/handle-step-meituan.png" alt width="850px;" />
      </div>
      <!-- <p style="text-align:center;">
  <el-button  type="primary" >发送短信邀请链接给服务者</el-button>
      </p>-->
      <span slot="footer" class="dialog-footer">
        <el-button @click="tipVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
//servantRecommend

import commutilData from "@/components/common/commutil.data";
import workercrmapi from "@/script/api/workercrmapi";
import wmsApi from "@/script/api/wmsApi";
import moment from "moment";
import {
  validatePhoneTwo,
  validateIdNo,
  validateIdNoOrNull,
  validateNumber
} from "@/script/validator";
import globalData from "@/components/common/globaldata/global.data.vue";

import lrz from "lrz";
export default {
  components: {},
  data() {
    return {
      fileListFront:[],
      fileListBack:[],
      cityList: [],
      workTypes: [
        { value: 1, label: "保洁" },
        { value: 2, label: "保姆" },
        { value: 3, label: "品类" }
      ],
      workerManager: [],
      cityId: "",
      buzLine: 1,
      stepStatus: 1, //表示上线已完成到第几步：1信息完善 2背调 3签约 4正式上线
      workerSupplierId: "",
      fileFrontPhoto: "",
      fileBackPhoto: "",
      backImgShow:true,
      isIdcard: false,
      serviceModelList: commutilData.serviceModelList,
      resCardID: "",
      resmessageres: "",
      resfranch: "",
      readMsgState: false,
      workIdCardWrong: "",
      workIdCardScore: "",
      workIdCardReason: "",
      workIdCard: "",
      workerResource: "",
      phoneWorker: "",
      tipVisible: false,
      nationList: commutilData.nationList, //民族
      zodiacList: commutilData.zodiacList, //生肖
      constellationList: commutilData.constellationList, //星座
      birthplaceList: commutilData.birthplaceList, //籍贯
      addVisible: false,
      workExperienceData: [],
      addLoading: false,
      workExpVisible: false,
      servantIdCardPic: {
        cityId: "",
        stationId: "",
        buzLine: 1,
        workerTel: "",
        ocrState: "",
        workerNo: "",
        workerName: "",
        idcardFront: "",
        idcardBack: "",
        idcardStartdate: "",
        idcardEnddate: "",
        idCardAddress: "",
        nativePlace: "",
        gender: "",
        workerIdcard: ""
      },
      servantWorkExpForm: {
        startTime: "",
        endTime: "",
        workContent: "",
        workDesc: ""
      },
      servantHandleInfo: {
        nation: "",
        religion: "",
        servantTel: "",
        marriage: "",
        workExperience: "",
        mandarin: "",
        serviceModel: "",
        currentAddress: "",
        bear: "",
        education: "",
        emergencyContact: "",
        emergencyPhone: "",
        cidName: "",
        cidNumber: "",
        cidAddr: "",
        logicBornplace: "",
        logicAnimalSign: "",
        birthday: "",
        startTime: "",
        endTime: "",
        nickname: "",
        weight: "",
        height: "",
        comments: "",
        isGold: "0",
        guaranteeAmount: null,
        guaranteeStart: null,
        guaranteeEnd: null,
        guaranteeDate: [],
        workerManagerId: ""
      },
      userAccount: "",
      date: "",
      mysetInterval: "",
      age: "",

      required: {},
      intervalTimes: 0,
      TimeFlag: false,
      rules: {
        cityId: [{ required: true, message: "请选择城市", trigger: "change" }],
        stationId: [{ required: true, message: "请选择服务站", trigger: "change" }],
        workerTel: [
          {
            required: true,
            message: "请输入服务者联系方式",
            trigger: "blur"
          },
          {
            validator: validatePhoneTwo,
            message: "手机号码格式错误",
            trigger: "blur"
          }
        ],
        workerName: [
          { required: true, message: "请填写姓名", trigger: "blur" }
        ],
        workerIdcard: [
          { required: true, message: "请填写身份证号码", trigger: "blur" },
          {
            validator: validateIdNoOrNull,
            message: "身份证号码格式错误",
            trigger: "blur"
          }
        ],
        buzLine: [
          { required: true, message: "请选择业务线", trigger: "change" }
        ],

        serviceChannel: [
          { required: true, message: "请选择服务渠道", trigger: "blur" }
        ],
        serviceOrderAllot: [
          { required: true, message: "请选择接单举例", trigger: "blur" }
        ],

        startTime: [
          {
            required: true,
            message: "请选择身份证有效期开始时间",
            trigger: "change"
          }
        ],
        endTime: [
          {
            required: true,
            message: "请选择身份证有效期结束时间",
            trigger: "change"
          }
        ],
        birthday: [
          { required: true, message: "请选择生日日期", trigger: "change" }
        ],
        height: [
          { pattern: new RegExp(/^[1-9]\d*$/, "g"), message: "请输入数字!" }
        ],
        weight: [
          { pattern: new RegExp(/^[1-9]\d*$/, "g"), message: "请输入数字!" }
        ],
        age: [
          { pattern: new RegExp(/^[1-9]\d*$/, "g"), message: "请输入数字!" }
        ]
      },
      addRules: {
        startTime: [
          { required: true, message: "请选择开始日期", trigger: "change" }
        ],
        endTime: [
          { required: true, message: "请选择结束日期", trigger: "change" }
        ],
        workContent: [
          { required: true, message: "请填写工作内容", trigger: "blur" }
        ],
        workDesc: [
          { required: true, message: "请填写工作描述", trigger: "blur" }
        ]
      },
      workerInfo: {}
    };
  },

  methods: {
    addServantData(workerSupplierId, cityId, buzLine, stepStatus, date, row) {
      this.fileFrontPhoto = "";
      this.fileBackPhoto = "";
      this.fileListFront=[];
      this.fileListBack=[];
      this.servantIdCardPic = {
        cityId: "",
        buzLine: 1,
        workerTel: "",
        ocrState: "",
        workerNo: "",
        workerName: "",
        idcardFront: "",
        idcardBack: "",
        idcardStartdate: "",
        idcardEnddate: "",
        idCardAddress: "",
        nativePlace: "",
        gender: "",
        workerIdcard: ""
      };

      this.addVisible = true;
      // this.userAccount = globalData.userInfo.userAccount;
      this.date = date;
      this.getAllCity();
      this.getAllStationList();
    },
    getAllCity() {
      //城市下拉框
      wmsApi.$axiosgetallCity({ userId: globalData.userInfo.id }).then(res => {
        if (res.data.errno == 0) {
          this.cityList = res.data.data;
        }
      });
    },
     getAllStationList() {
            //服务站
            wmsApi
                .$axiosGetAllStationList({ userId: globalData.userInfo.id })
                .then((res) => {
                    if (res.data.errno == 0) {
                        this.allStationList = res.data.data;
                    }
                });
        },
    //确定新增商家
    confAddServantBtn(formName) {
    // this.tipVisible=true;
      if (
        this.servantIdCardPic.workerName == "" ||
        this.servantIdCardPic.workerIdcard == ""
      ) {
        this.$message.warning("请上传身份证正反面照片，再点击‘确认识别’按钮！");
        return;
      }

      this.$refs[formName].validate(valid => {
        if (valid) {
          let agent = this.servantIdCardPic;
          console.log(agent);
          workercrmapi
            .$axiosaddMeiTuanWorker(agent)
            .then(res => {
              if (res.data.errno == 0) {
                this.$message.success("添加成功");
                this.$parent.querySearch();
                this.addVisible = false;
                this.tipVisible = true;
              } else {
                // this.tipVisible = true;
                // this.resfranch = res.data.data;
                this.$message.warning(res.data.errMsg);
              }
            })
            .catch(err => {
              console.log(err);
            });
        } else {
          console.log("err");
        }
      });
    },

    //确认识别身份证照片
    confIdentifyBtn() {
      console.log(this.fileFrontPhoto);
      if (
        this.fileFrontPhoto == null ||
        this.fileBackPhoto == null ||
        this.fileFrontPhoto == "" ||
        this.fileBackPhoto == ""
      ) {
        this.$message.warning("请上传身份证正面照片或反面照片！");
        return false;
      }
      const loading = this.$loading({
        lock: true,
        text: "正在识别身份证照片中，请耐心等候...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });

      let temp = new FormData();
      // temp.append("workerSupplierId", this.workerSupplierId);
      temp.append("frontPhoto", this.fileFrontPhoto);
      temp.append("backPhoto", this.fileBackPhoto);
      // temp.append("operatorId", globalData.userInfo.id);
      // temp.append("operatorName", globalData.userInfo.userName);

      workercrmapi
        .$axiosgetOcrVerifyNew(temp)
        .then(res => {
          loading.close();
          this.readMsgState = true;
          if (res.data.errno == 0) {
            if (res.data.data.ocrState == 1) {
              this.servantIdCardPic = {
                ocrState: res.data.data.ocrState,
                workerNo: res.data.data.workerNo,
                workerName: res.data.data.workerName,
                idcardFront: res.data.data.idcardFront,
                idcardBack: res.data.data.idcardBack,
                idcardStartdate: res.data.data.idcardStartdate,
                idcardEnddate: res.data.data.idcardEnddate,
                idcardAddress: res.data.data.idcardAddress,
                nativePlace: res.data.data.nativePlace,
                gender: res.data.data.gender,
                nation:res.data.data.nation,
                workerIdcard: res.data.data.workerIdcard
              };
            } else {
              this.servantIdCardPic = {
                ocrState: res.data.data.ocrState,
                workerNo: "",
                workerName: ""
              };
              this.$message.warning(res.data.data.failMsg);
            }
          } else {
            this.$message.warning(res.data.data.msg);
          }
        })
        .catch(err => {
          console.log(err);
          loading.close();
        });
    },

    //上传身份证正面
    handleOnChangeA(file, fileListA) {
      // console.log(file);
      this.fileListFront=fileListA;
      console.log("文件大小：", file.raw.size / 1024 / 1024 + "M");
      this.fileFrontPhoto =file.raw;
      // if (file.raw) {
      //   lrz(file.raw, { quality: 0.9 }).then(rst => {
      //     this.fileFrontPhoto = rst.origin;
      //     console.info(this.fileFrontPhoto);
      //   });
      // }
    },
    //上传身份证反面
    handleOnChangeB(file, fileListA) {
      this.fileListBack=fileListA;
      console.log(file.raw);
      this.fileBackPhoto =file.raw;
      // if (file.raw) {
      //   lrz(file.raw, { quality: 0.9 }).then(rst => {
      //     this.fileBackPhoto = rst.origin;
      //     console.log(this.fileBackPhoto);
      //   });
      // }
    },
    beforeAvatarUploadA(file) {
      console.log("jianlai", file);
      const isJPG = file.type === "image/jpeg" || "image/jpg" || "image/png";
      const isLt2M = file.size / 1024 / 1024 < 5;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG/PNG/JEPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 5MB!");
      }
      return isJPG && isLt2M;
    },
    handleRemoveA(file, fileListA) {
      console.log(file, fileListA);
      console.log("关闭");
      this.fileFrontPhoto = null;
       this.fileListFront=[];
      this.servantIdCardPic = {
        cidName: "",
        cidNumber: "",
        cidAddr: "",
        logicBornplace: "",
        birthday: "",
        logicAnimalSign: "",
        frontIdcardFullPath: "",
        frontIdcardName: "",
        backIdcardFullPath: "",
        backIdcardName: "",
        validPeriodDate: "",
        age: "",
        idValidityEnddate: "",
        idValidityStartdate: "",
        frontIdcardurl: "",
        backIdcardurl: ""
      };
    },
    handleRemoveB(file, fileListB) {
      console.log(file, fileListB);
      this.fileBackPhoto = null;
      this.fileListBack=[];
      this.backImgShow=false;
      this.servantIdCardPic = {
        cidName: "",
        cidNumber: "",
        cidAddr: "",
        logicBornplace: "",
        birthday: "",
        logicAnimalSign: "",
        frontIdcardFullPath: "",
        frontIdcardName: "",
        backIdcardFullPath: "",
        backIdcardName: "",
        validPeriodDate: "",
        age: "",
        idValidityEnddate: "",
        idValidityStartdate: "",
        frontIdcardurl: "",
        backIdcardurl: ""
      };
      console.log("关闭");
    },


  }
};
</script>
<style scoped>
.servantHandleInfo .el-form-item--mini.el-form-item,
.servantHandleInfo .el-form-item--small.el-form-item {
  margin-bottom: 15px !important;
}

.share-servant-wrapper {
  text-align: right;
  font-size: 16px;
  padding: 0 20px 0 0;
}

/* .el-input--suffix{
display: flex;
}
.el-input-group__append{
  line-height: 32px !important;
} */
.el-form--inline .el-form-item {
  margin-right: 0px;
}

.el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
  margin-bottom: 5px;
}
</style>
